import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "badge"]

    connect() {
        console.log("Release Notes Modal Controller connected")
        this.checkIfUserHasSeenReleaseNotes()
    }

    open() {
        console.log("Opening release notes modal")
        this.modalTarget.classList.remove("hidden")
        this.modalTarget.style.display = "block"
        document.body.style.overflow = "hidden"
        
        // Mark as seen when opened
        this.markAsSeen()
    }

    close() {
        console.log("Closing release notes modal")
        this.modalTarget.classList.add("hidden")
        this.modalTarget.style.display = "none"
        document.body.style.overflow = "auto"
    }

    stopPropagation(event) {
        event.stopPropagation()
    }

    async markAsSeen() {
        try {
            const response = await fetch('/backend/release_notes/mark_as_seen', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                }
            })
            
            if (response.ok) {
                // Hide the badge
                if (this.hasBadgeTarget) {
                    this.badgeTarget.style.display = 'none'
                }
            }
        } catch (error) {
            console.error('Error marking release notes as seen:', error)
        }
    }

    async checkIfUserHasSeenReleaseNotes() {
        try {
            const response = await fetch('/backend/release_notes/seen_status')
            const data = await response.json()
            
            if (data.has_seen) {
                // Hide the badge if user has already seen this version
                if (this.hasBadgeTarget) {
                    this.badgeTarget.style.display = 'none'
                }
            } else {
                // Show the badge if user hasn't seen this version yet
                if (this.hasBadgeTarget) {
                    this.badgeTarget.style.display = 'inline-flex'
                }
            }
        } catch (error) {
            console.error('Error checking release notes status:', error)
            // On error, show the badge by default
            if (this.hasBadgeTarget) {
                this.badgeTarget.style.display = 'inline-flex'
            }
        }
    }
}